module.exports = __webpack_public_path__ + "static/media/Divyashree-C.53a032ad.svg";